import React from 'react';
import ApolloDataExportItem from '../Domain/ApolloDataExportItem.js';
import serviceHelper from '../Helpers/serviceHelper.js';
import AuthService from './authService.js';
import SearchParams from '../Elements/SearchParams';
import ApolloDataExportSearchParams from '../Contents/RoverImport/ApolloDataExportAdmin/ApolloDataExportSearchParams';

class ApolloDataExportService extends React.Component {
  static GetListBySearching(orderById, orderDir, pageNumber, numberOfElements, searchItem) {
    const searchParams = new SearchParams(searchItem, ApolloDataExportSearchParams, orderById, orderDir, pageNumber, numberOfElements);

    const url = `/api/ApolloDataExport/GetAllBySearchingAsync/?searchParams=${searchParams.serializeForBackendCall()}`;

    return AuthService.getInstance().CallBackendFunction(url);
  }

  static ConvertDBItems(itemlist) {
    let mappedItems = [];

    if (itemlist !== null) {
      mappedItems = itemlist.map((item) => new ApolloDataExportItem(item));
    }

    return mappedItems;
  }

  static StartExportManually(id) {
    const url = '/api/ApolloDataExport/StartExportManuallyAsync';
    const json = {
      input: null,
      id,
    };
    const jsonStr = JSON.stringify(json);
    return AuthService.getInstance().CallBackendFunctionPost(url, jsonStr);
  }

  static EditApolloDataExport(apolloDataExport) {
    apolloDataExport = serviceHelper.ConvertAllPropertyToString(apolloDataExport);
    let apolloDataExportJSON = JSON.stringify(apolloDataExport);

    return AuthService.getInstance().CallBackendFunctionPut(
      '/api/ApolloDataExport/EditApolloDataExport',
      apolloDataExportJSON
    );
  }
}

export default ApolloDataExportService;
